<template>
  <Editor  v-if="is_load" ref="editor" :config="config"/>
</template>

<script>
import UserModel from "./UserModel";
import Vue from "vue";
import AnyButton from "editorjs-button";
import MapPlugin from "./MapPlugin";
import MapsPlugin from "./MapsPlugin";
import Api from "./Api";

// import paragraph from "@/models/paragraph/paragraph.js";
import TelegramEmbed from "@/models/blocks/TelegramEmbed";
import RutubeEmbed from "@/models/blocks/RutubeEmbed";
import VkVideoEmbed from "./blocks/VkVideoEmbed";
import VkClipsEmbed from "./blocks/VkClipsEmbed";
import LinkToolNew from "@/models/blocks/LinkToolNew";
import Embed from "@/models/blocks/Embedbundle.js";
import Image from "@/models/blocks/ImageBundle.js";
import FIgmaEmbed from "@/models/blocks/FigmaEmbed";
import Vote from "@/models/blocks/Vote";
import { loadScript } from "vue-plugin-load-script";




export default {
  name: "Editorjsinput",
  data() {

    var app = this;

    return {
      'is_load':false,
      'config':[],
      'user':[],
      'save_data':null,



    }
  },
  props: {
    blocks_json: {
      type: Array,
      required: true
    },
    onlyimage:{
      type:Boolean,
      required:false,
      default:false,
    }

  },
  mounted: function () {
    var url_carousel=Vue.config.IMAGE_URL+"js/carousel_editor.js";

    var app = this;

    var tmpUser=UserModel.get();
    if(tmpUser){

      app.updateEditorJs(tmpUser.api_token);
    }

  },
  methods:{
    save(success){
      var app=this;
      app.$refs.editor._data.state.editor.save()
          .then((data) => {
            // Do what you want with the data here
            app.save_data=data;

            success(data);
            // app.$emit('save', {
            //   data: app.save_data,
            // })


          })
          .catch(err => {

          })
    },
    updateEditorJs(api_token="") {

      var image_lang_tool_name="Фото или Видео";
      var image_lang_tool_arr={
        "title":"Фото или видео",
        'Couldn’t upload image. Please try another.':'Произошла ошибка при загрузке изображения или видео.',
      };
      var image_config={
        additionalRequestHeaders: {
          "Authorization": 'Bearer ' + api_token
        },
        types:"image/*,video/mp4,video/avi,video/quicktime",
        'captionPlaceholder':"Введите заголовок",
        'buttonContent':'загрузите &nbsp;<i class="fa fa-photo"></i>&nbsp; или &nbsp;<i class="fa fa-video-camera"></i>&nbsp;(50MB)',
        endpoints: {
          byFile: Vue.config.API_URL + 'editor/uploadImageVideo', // Your backend file uploader endpoint

        }

      };
      if(this.onlyimage==true){
        image_lang_tool_name="Фото";
        var image_lang_tool_arr={
          "title":"Фото",
          'Couldn’t upload image. Please try another.':'Произошла ошибка при загрузке изображения',
        };
        var image_config={
          additionalRequestHeaders: {
            "Authorization": 'Bearer ' + api_token
          },
          types:"image/*",
          'captionPlaceholder':"Введите заголовок",
          'buttonContent':'загрузите &nbsp;<i class="fa fa-photo"></i>&nbsp;(50MB)',
          endpoints: {
            byFile: Vue.config.API_URL + 'editor/uploadImage', // Your backend file uploader endpoint

          }

        };
      }







      this.config = {
        placeholder: 'Нажмите Tab или кнопку + для выбора инструмента',
        i18n: {
          /**
           * @type {I18nDictionary}
           */
          messages: {
            /**
             * Other below: translation of different UI components of the editor.js core
             */
            ui: {
              "blockTunes": {
                "toggler": {
                  "Click to tune": "Нажмите, чтобы настроить",
                  "or drag to move": "или перетащите"
                },
              },
              "inlineToolbar": {
                "converter": {
                  "Convert to": "Конвертировать в"
                }
              },
              "toolbar": {
                "toolbox": {
                  "Add": "Добавить"
                }
              }
            },

            /**
             * Section for translation Tool Names: both block and inline tools
             */
            toolNames: {
              "Button":"Кнопка",
              "Carousel":"Галлерея",
              "Text": "Параграф",
              "Heading": "Заголовок",
              "List": "Список",
              "Warning": "Примечание",
              "Checklist": "Чеклист",
              "Quote": "Цитата",
              "Code": "Код",
              "Delimiter": "Разделитель",
              "Raw HTML": "HTML-фрагмент",
              "Table": "Таблица",
              "Link": "Ссылка",
              "Marker": "Маркер",
              "Bold": "Полужирный",
              "Italic": "Курсив",
              "InlineCode": "Моноширинный",
              'Image':image_lang_tool_name,
              'Attachment':'Файл',
            },

            /**
             * Section for passing translations to the external tools classes
             */
            tools: {
              /**
               * Each subsection is the i18n dictionary that will be passed to the corresponded plugin
               * The name of a plugin should be equal the name you specify in the 'tool' section for that plugin
               */
              "header":{
                "title":"Заголовок",
              },
              "AnyButton": {
                'Button Text': 'текст отображения на кнопке',
                'Link Url': 'Ссылка',
                'Set': "Создать кнопку",
                'Default Button': "По умолчанию",
              },



              "image":image_lang_tool_arr,
              "warning": { // <-- 'Warning' tool will accept this dictionary section
                "Title": "Название",
                "Message": "Сообщение",
              },

              /**
               * Link is the internal Inline Tool
               */
              "link": {
                "Add a link": "Вставьте ссылку"
              },
              /**
               * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
               */
              "stub": {
                'The block can not be displayed correctly.': 'Блок не может быть отображен'
              }
            },

            /**
             * Section allows to translate Block Tunes
             */
            blockTunes: {
              /**
               * Each subsection is the i18n dictionary that will be passed to the corresponded Block Tune plugin
               * The name of a plugin should be equal the name you specify in the 'tunes' section for that plugin
               *
               * Also, there are few internal block tunes: "delete", "moveUp" and "moveDown"
               */
              "delete": {
                "Delete": "Удалить"
              },
              "moveUp": {
                "Move up": "Переместить вверх"
              },
              "moveDown": {
                "Move down": "Переместить вниз"
              }
            },
          }
        },

        tools: {

          header: {
            class:require('editorjs-header-with-alignment'),
            config:{
              placeholder:"Заголовок",
            }
          },
          paragraph: {
             class: require('editorjs-paragraph-with-alignment'),
            // class:paragraph,

            inlineToolbar: true,
            config:{
              placeholder:"Нажмите Tab или кнопку + для выбора инструмента",
            }
          },
          'vote':{
            class:Vote,
            config:{
              url:{
                create_vote:Vue.config.API_URL + 'editor/createVote?api_token=' + api_token,
                get_vote:Vue.config.API_URL + 'editor/showVote/id',
              }
            }
          },

          image: {
            class: window.ImageTool,
            inlineToolbar: true,
            config:image_config
          },
          attaches: {
            class: require('@editorjs/attaches'),
            config: {
              buttonText:"Загрузить файл(до 50МБ)",
              errorMessage:"При загрузке файла произошла ошибка. Максимальный размер файла 50мб",
              endpoint: Vue.config.API_URL + 'editor/uploadFile?api_token=' + api_token,
            }
          },
          carousel: {
            class: require('@vtchinh/gallery-editorjs'),
            inlineToolbar: true,
            config: {
              endpoints: {
                byFile: Vue.config.API_URL + 'editor/uploadImage',
                // removeImage: "URL_FETCH", //default null
              },
              additionalRequestHeaders: {
                "Authorization": 'Bearer ' + api_token

                // ...
              },
              field: 'image',
              types: 'image/*',
              // additionalRequestData: { // for custom data
              //     name: 'your custom data name',
              //     order_data: 'your order custom data',
              // },
              // galleryCallback: 'your_prefer_callback_data' // object return is required
            }
          },
          list: {
            class: require('@editorjs/list'),
            inlineToolbar: true,
          },

          inlineCode: {
            class: require('@editorjs/inline-code'),
            shortcut: 'CMD+SHIFT+M',
          },
          AnyButton: {
            class: AnyButton,
            inlineToolbar: false,
            config:{
              css:{
                "btnColor": "btn--gray",
              }
            }
          },
          figma:FIgmaEmbed,
          telegramembed:TelegramEmbed,
          rutubeembed:RutubeEmbed,
          vkvideoembed:VkVideoEmbed,
          vkclipsembed:VkClipsEmbed,
          embed: window.Embed,
          linkTool: {
            class: LinkToolNew,
            config: {
              endpoint: Vue.config.API_URL + 'editor/fetchUrl?api_token='+ api_token, // Your backend endpoint for url data fetching
            }
          },
          Marker: {
            class: require('@editorjs/marker'),
            shortcut: 'CMD+SHIFT+M',
          },
          table: {
            class: require('@editorjs/table'),
          },

          delimiter: require('@editorjs/delimiter'),
          quote: {
            class: require('@editorjs/quote'),
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+O',
            config: {
              quotePlaceholder: 'Enter a quote',
              captionPlaceholder: 'Quote\'s author',
            },
          },


          warning: require('@editorjs/warning'),

          checklist: {
            class: require('@editorjs/checklist'),
            inlineToolbar: true,
          },

          maps:{
            class:MapsPlugin,
            config:{
              url:Vue.config.API_URL + "editor/search_one_adress",
            }
          }
        },
        "data": {
          "time": 1591362820044,
          "blocks": [
            {
              "type": "header",
              "data": {
                "text": "",
                "level": 2
              }
            },
            {
              "type": "paragraph",
              "data": {

                "text": "",
              }
            },

          ]
        }
      };



      if(this.blocks_json && this.blocks_json.length>0){
        this.config.data.blocks=this.blocks_json;
      }
      this.is_load=true;
    }
  }
}
</script>

<style scoped>

</style>